/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { useNavigate } from 'react-router-dom';
import MikeButton from '../mike-button/MikeButton';
import { ReactNode, useCallback } from 'react';
import Left from '../../icons/Left.svg?react';
import { iconStyle } from '../../styles/iconStyles';

const rootStyle = 
  css`
    padding: ${mikeSharedTheme.spacing(1)}; 
  `;

interface IProps {
  children?: ReactNode;
};

function PageContainer(props: IProps){   
  const navigate = useNavigate();
    const handleSelect = useCallback(() => {
    navigate('/');
  }, [navigate])

    return  (  
        <div css={rootStyle}>
          <MikeButton onClick={handleSelect}><Left css={iconStyle}/>{"Zurück zur Maßnahmen-Erfassung"}</MikeButton>
          {props.children}
        </div> 
    )
}

export default PageContainer